// extracted by mini-css-extract-plugin
var _1 = "zoYC5roBSJevLe4_V9kc";
var _2 = "TdDC3d847YAoyaj6PwFd";
var _3 = "HEmHnyAk4DYjZ6Lcm6TR";
var _4 = "FFQ7stT87nndw6h16wQu";
export { _1 as "bigger", _2 as "browserSupport", _3 as "browserSupportOutdated", _4 as "browserSupportUnsupported" }
export default { "bigger": _1, "browserSupport": _2, "browserSupportOutdated": _3, "browserSupportUnsupported": _4 }
